// Client-side, no-page-reload fetch of an athlete's habit logs for an
// arbitrary date range — mirrors js/load/habit-logs.js's own "habitLogs"
// query construction exactly. Powers Nutrition Progress's on-demand history
// extension (useExtendedHistoryData) when the coach picks a range older than
// what the initial page load fetched (nutrition.controller.js caps
// habitLogs to a trailing 1-year window).

import moment from "moment";
import { jsonGetRoute } from "./json-get-route";

const HabitLogs = (app) => {
  app.get(
    "/habit-logs",
    jsonGetRoute(
      ({ req }) => {
        const { start, end, proxyAthlete } = req.query || {};
        return [
          "habit-logs",
          {
            query: {
              proxyAthlete,
              startDate: moment(start).format("YYYY-MM-DD"),
              endDate: moment(end).format("YYYY-MM-DD"),
            },
          },
        ];
      },
      (data) => data?.habitLogs ?? []
    )
  );
};

export default HabitLogs;
